import React from "react";
import Section from "components/Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "components/SectionHeader";

function PrivacyPolicy(props) {
  return (
    <Section>
      <Container>
              <SectionHeader
                className="text-center"
                title="Privatumo politika"
                size={1}
                spaced={true}
              />

            <div className="text">
              <h2> 1. Kam skirta ši Privatumo politika? </h2>
              <p>
                Ši privatumo politika (toliau –- Privatumo politika) skirta
                visiems interneto svetainės{" "}
                <a href="/"> www.trymycar.com </a> (toliau
                – Svetainė) lankytojams, <strong>UAB „Nuomos sistema“</strong>{" "}
                (juridinio asmens kodas 305239605, registracijos adresas
                Santariškių g. 75-34, LT-08457 Vilnius) (toliau – Nuomos sistema
                arba Mes) paslaugų gavėjams, prekių įgijėjams, asmenims,
                atlikusiems aktyvius veiksmus Nuomos sistema socialinės
                žiniasklaidos paskyrose, bei asmenims, sutikusiems gauti Nuomos
                sistema tiesioginės rinkodaros pasiūlymus, taip pat asmenims,
                dalyvaujantiems renginiuose. Privatumo politika numato
                pagrindines asmens duomenų tvarkymo taisykles ir apibrėžia
                sąlygas, kurių privalo laikytis aukščiau išvardinti asmenys.
              </p>
              <p>
                Mes rūpinamės Jūsų privatumu, todėl asmens duomenis tvarkome
                vadovaujantis Europos Parlamento ir Tarybos Bendruoju duomenų
                apsaugos reglamentu (ES) 2016/679 (toliau – Reglamentas), Asmens
                duomenų teisinės apsaugos įstatymu (2018-06-30 Nr. XIII-1426) ir
                kitais asmens duomenų apsaugą reglamentuojančiais teisės aktais.
                Būtinai skirkite laiko Privatumo politikos peržiūrėjimui ir
                kilus klausimų, nedvejodami susisiekite su Mumis nurodytais
                kontaktais.
              </p>
              <p>
                Kai Jūs lankotės Svetainėje, užsisakote svetainėje siūlomas
                paslaugas, atliekate aktyvius veiksmus Nuomos sistema socialinės
                žiniasklaidos paskyrose, dalyvaujate mūsų renginiuose ar
                sutinkate, kad Nuomos sistema su Jumis susisiektų ir (ar) teiktų
                rinkodaros medžiagą, Mes laikysime, kad Jūs perskaitėte ir
                susipažinote su šia Privatumo politika.
              </p>
              <h2>2. Apie mus</h2>
              <p>
                Mes esame Jūsų asmens duomenų valdytojas. Turėdami klausimų ar
                nusiskundimų dėl Asmens duomenų tvarkymo, galite kreiptis į
                Duomenų valdytojo paskirtą duomenų apsaugos pareigūną el. pašto
                adresu{" "}
                <a href="mailto:info@trymycar.com?subject = Dėl mano duomenų tvarkymo&body = Jūsų žinutė ar klausimas mums">
                  {" "}
                  info@trymycar.com{" "}
                </a>{" "}
                arba turite galimybę užregistruoti savo kreipimąsi paskambinęs
                telefonu <strong>+370 625 13762</strong>.
              </p>
              <p>
                Atkreipiame dėmesį, kad paspaudę aktyvias nuorodas Mūsų
                svetainėje, Jūs galite būti nukreipti į kitas svetaines, kuriose
                duomenis gali tvarkyti ir kiti duomenų valdytojai, todėl
                visuomet rekomenduojame susipažinti su svetainės, kurioje
                lankotės, privatumo politika.
              </p>
              <h2>3. Kas yra asmens duomenys?</h2>
              <p>
                Asmens duomenys yra bet kokia Mūsų apie Jus renkama informacija,
                kuri gali būti panaudota Jūsų asmens tapatybei nustatyti bei yra
                saugoma elektroniniu ar kitu būdu. Asmens duomenys apima bet
                kokią informaciją, įskaitant Jūsų vardą, pavardę, adresą, IP
                adresą, transporto priemonės valstybinį numerį, kurią apie Jus
                Nuomos sistema renka dėl šioje Privatumo politikoje ar atskirame
                Jūsų sutikime ar susitarime su Nuomos sistema nurodytų tikslų.
                Informaciją Jūs pateikiate naršydami svetainėje, bendraudami su
                Mumis el. paštu ar per pokalbių skiltį interneto svetainėje,
                užpildydami registracijos ar užklausų formas Mūsų svetainėje.
              </p>
              <p>
                Asmens duomenys taip pat apima viešoje erdvėje esančią Jūsų
                asmeninę informaciją, su kuria susipažįstame Jums susisiekus su
                mumis socialinės žiniasklaidos priemonėmis ar atlikus aktyvius
                veiksmus Nuomos sistema socialinės žiniasklaidos priemonių
                paskyrose.
              </p>
              <h2>
                4. Kodėl ir kaip renkame bei naudojame Jūsų asmens duomenis?
              </h2>
              <p>
                Nuomos sistema yra reikalingi Jūsų asmens duomenys, kurie gali
                būti renkami toliau aprašomais būdais. Privatumo politikoje
                nurodome, ko galite tikėtis, kai įmonė renka asmens duomenis
                apie:
              </p>
              <ul>
                <li>svetainės lankytojus;</li>
                <li>
                  socialinės žiniasklaidos priemonių naudotojus, kurie bet kokiu
                  būdu kreipiasi į Nuomos sistema per Nuomos sistema paskyras
                  socialinės žiniasklaidos priemonėse ar aktyviais veiksmais
                  jose dalyvauja;
                </li>
                <li>
                  su mumis susisiekusius asmenis (el. paštu, telefonu ar per
                  pokalbių skiltį interneto svetainėje);
                </li>
                <li>
                  asmenis, kurie registruojasi Mūsų naujų paslaugų ir (arba)
                  riboto rato paslaugų testavimui;
                </li>
                <li>
                  asmenis, kurie sutinka gauti Mūsų tiesioginės rinkodaros
                  pasiūlymus.
                </li>
              </ul>
              <h3>Mūsų interneto svetainių lankytojai</h3>
              <p>
                Kai lankotės šioje interneto svetainėje, duomenys apie Jūsų
                naršymą svetainėje ir kt., yra renkami naudojantis slapukais.
              </p>
              <p>
                Nuomos sistema naudoja būtinuosius / techninius slapukus, kad
                galėtų užtikrinti tinkamą svetainės veikimą ir (ar) kitus
                trečiųjų šalių slapukus, kad galėtų gerinti jūsų naršymo patirtį
                (t. y. atsižvelgti į jūsų poreikius, nuolat tobulinti svetainę
                ir teikti pasiūlymus, atitinkančius jūsų interesus).
              </p>
              <p>
                Duomenys, gaunami panaudojant slapukus ir panašias
                technologijas, susijusias su naršymu internete ir pan., renkami
                (tvarkomi) vadovaujantis Reglamento 6 str. 1 d. a) p., t. y.
                Jūsų sutikimu (išskyrus būtinieji slapukai). Daugiau
                informacijos apie slapukus galite rasti svetainės{" "}
                <a href="/cookie-policy">
                  {" "}
                  Slapukų Politikoje
                </a>
                .
              </p>
              <h3>Socialinės žiniasklaidos priemonės</h3>
              <p>
                Visą informaciją, kurią mums pateikiate komunikuodami su mumis
                socialinės žiniasklaidos priemonėmis (įskaitant pranešimus,
                laukelių „Like“ ir „Follow“ naudojimą, bei kitą komunikaciją),
                Numos sistema valdo kartu su konkretaus socialinio tinklo
                valdytoju (socialinio tinklo platformoje).
              </p>
              <p>
                Mūsų interneto svetainėje pateikiamos nuorodos į mūsų paskyras
                socialinės žiniasklaidos priemonėse. Tam, kad galėtume tinkamai
                atstovauti ir didinti Nuomos sistema paslaugų žinomumą viešoje
                erdvėje, administruojame šias paskyras socialiniuose tinkluose:
              </p>
              <ul>
                <li>
                  Tinkle <strong>„Facebook“</strong> @trymycar „Facebook“
                  privatumo pranešimas yra pateikiamas adresu{" "}
                  <a href="https://www.facebook.com/privacy/explanation/">
                    https://www.facebook.com/privacy/explanation/
                  </a>
                </li>
                <li>
                  Tinkle <strong>„Youtube“</strong> – trymycar „Youtube“
                  privatumo pranešimas yra pateikiamas adresu{" "}
                  <a href="https://policies.google.com/privacy?hl=en-US/">
                    https://policies.google.com/privacy?hl=en-US/
                  </a>
                  "
                </li>
                <li>
                  Tinkle <strong>“LinkedIn“</strong> @trymycar “LinkedIn“
                  privatumo pranešimas yra pateikiamas adresu:{" "}
                  <a href="https://www.linkedin.com/psettings/data-privacy">
                    https://www.linkedin.com/psettings/data-privacy
                  </a>
                  .
                </li>
              </ul>
              <p>
                Socialinio tinklo paskyroje pateiktus Jūsų asmens duomenis
                tvarkome vadovaujantis Reglamento 6 str. 1 d. a) p., t. y. Jūsų
                sutikimu.
              </p>
              <p>
                Jūsų pateiktus asmens duomenis, Mes tvarkome iki Jūsų sutikimo
                atšaukimo (t. y. pateiktų asmens duomenų ištrynimo iš paskyros)
                momento, tačiau neilgiau nei iki Bendrovės paskyros ištrynimo.
                Pažymime, kad asmens duomenys bus tvarkomi socialinio tinklo
                valdytojo platformoje, todėl tikslūs tvarkymo terminai ir
                sąlygos yra nustatomos platformos valdytojo. Atsižvelgiant į
                tai, rekomenduojame perskaityti trečiųjų šalių privatumo
                pranešimus ir (ar) tiesiogiai susisiekti su paslaugų teikėjais,
                jei Jums kyla bet kokių klausimų dėl to, kaip jie naudoja Jūsų
                asmens duomenis.
              </p>
              <h3>Asmens duomenys, renkami su mumis susisiekus</h3>
              <p>
                Mūsų interneto svetainėje pateikti kontaktai, kuriais galite su
                mumis susisiekti, norėdami pasinaudoti mūsų teikiamomis
                paslaugomis ar pasikonsultuoti jums rūpimais klausimais. Visus
                Jūsų pranešimus priimsime, peržiūrėsime ir pateiksime atsakymus.
              </p>
              <ul>
                <li>
                  Jei su mumis susisieksite el. paštu, mes tvarkysime tokius
                  Jūsų duomenis: Jūsų vardą, pavardę, el. pašto adresą bei
                  susirašinėjimo tekstą ir (ar) pridedamus dokumentus. Šie
                  duomenys bus tvarkomi Jūsų paklausimų administravimo ir (ar)
                  pasirengimo sutarties sudarymui, sutarties vykdymui.
                  Komunikacija su Jumis bus tvarkoma iki pilno paklausimo
                  išnagrinėjimo ir saugoma 3 mėnesius nuo išnagrinėjimo dienos
                  arba pilno sutarties įvykdymo ir saugoma 10 metu, kartu su
                  sutartimi ir kitais dokumentais (t. y. sutartis ir apskaitos
                  dokumentai).
                </li>
                <li>
                  Jei su mumis susisieksite per pokalbių skiltį interneto
                  svetainėje, mes tvarkysime tokius Jūsų duomenis: Jūsų vardą,
                  pavardę, el. pašto adresą, telefono numerį bei susirašinėjimo.
                  Šie duomenys bus tvarkomi Jūsų paklausimų administravimo ir
                  (ar) pasirengimo sutarties sudarymui, sutarties vykdymui.
                  Komunikacija su Jumis bus tvarkoma iki pilno paklausimo
                  išnagrinėjimo ir saugoma 2 mėnesius nuo išnagrinėjimo dienos
                  arba pilno sutarties įvykdymo ir saugoma 10 metu, kartu su
                  sutartimi ir kitais dokumentais (t. y. sutartis ir apskaitos
                  dokumentai). Atkreipiame dėmesį, kad pokalbių skiltyje galite
                  bendrauti ir nepateikdami šios informacijos.
                </li>
                <li>
                  Jei su mumis susisiekiate telefonu (prieš pokalbio įrašymą
                  Duomenų subjektas informuojamas apie pokalbio įrašymą ir
                  tikslą), Jums sutikus pokalbis bus įrašomas, nesutikus prašome
                  Jūsų naudotis kitomis komunikavimo priemonėmis. Pokalbių
                  įrašai daromi siekiant užtikrinti kokybišką asmenų
                  konsultavimą bei objektyvų skundų išnagrinėjimą. Įrašant
                  pokalbį išsaugomi tokie jūsų duomenys: telefono numeris iš
                  kurio skambinate, telefoninio pokalbio įrašas. Tokia
                  informacija saugoma 6 mėnesius, po to sunaikinama.
                </li>
              </ul>
              <p>
                Visi asmens duomenys, kuriuos pateikiate bendraudami su mumis,
                yra naudojami tik aukščiau nurodytais tikslais ir pranešimams
                peržiūrėti bei komunikacijos srautams administruoti (valdyti) ir
                pateikti Jums atsakymą. Minėtus asmens duomenis tvarkysime
                vadovaujantis Reglamento 6 str. 1 d. a) p., t. y. Jūsų sutikimu,
                kurį išreiškiate susisiekdami su mumis el. paštu ir (ar) tęsdami
                pokalbį telefonu. Jeigu bendravimas bus skirtas sudaryti ir (ar)
                vykdyti su Jumis sudarytą sutartį, tuomet asmens duomenis
                tvarkysime vadovaujantis Reglamento 6 str. 1 d. b) p., t. y.
                siekiant sudaryti ir (ar) įvykdyti su duomenų subjektu sudarytą
                sutartį.
              </p>
              <p>
                Prašome atkreipti dėmesį, kad Mums gali tekti susisiekti su
                Jumis paštu, el. paštu arba telefonu, todėl neužmirškite
                pranešti Mums apie Jūsų asmens duomenų pasikeitimus.
              </p>
              <h3>
                Asmens duomenys, renkami apie naujų paslaugų ir (arba) riboto
                rato paslaugų testavimo vartotojus
              </h3>
              <p>
                Jums nusprendus išbandyti Mūsų riboto rato paslaugų testavimą,
                paprašysime Jūsų mums pateikti savo asmens duomenis. Tokie
                asmens duomenys apima vartotojo vardą, pavardę, adresą, asmens
                kodą, el. pašto adresą, telefono numerį ir mokėjimo duomenis,
                kuriuos privalome surinkti norėdami sudaryti su Jumis sutartį ir
                perduoti Jums automobilį. Taip pat paprašysime mums parodyti
                savo asmens identifikavimo dokumentą, vairuotojo pažymėjimą,
                civilinės atsakomybės ir/arba kasko draudimo sutartį. Šią Jūsų
                informaciją tvarkysime vadovaujantis Reglamento 6 str. 1 d. b)
                p., t. y. sudaryti su Jumis sutartį ir ją vykdyti, taip pat
                Reglamento 6 str. 1 d. c) p., t. y. mums taikoma teisine
                prievole saugoti sutartis ir apskaitos dokumentus bei Reglamento
                6 str. 1 d. f) p., t. y. mūsų teisėtu interesu pareikšti ir (ar)
                apginti savo teisinius reikalavimus (kai taikoma).
              </p>
              <p>
                Jūsu sutikimu galime paprašyti gauti duomenis apie jus iš
                trečiųjų šalių registrų. Tokiu atveju apie prašomų gauti duomenų
                apimtį būsite informuoti atskirai.
              </p>
              <p>
                Jei paslaugų bandymui registruojatės įmonės vardu, tačiau nesate
                asmuo, įgaliotas veikti įmonės vardu, taip pat prašysime
                pateikti dokumentus, įrodančius Jūsų teisę veikti įmonės vardu.
                Mums taip pat būtina žinoti Jūsų vardą, pavardę, adresą (jei šie
                duomenys nesutampa su paslaugos gavėjo duomenimis), kontaktinius
                duomenis, el. pašto adresą, įmonės pavadinimą (jei aktualu).
              </p>
              <p>
                Šią informaciją naudosime, kad galėtumėme valdyti ir
                administruoti Nuomos sistema vystomą automobilių dalinimosi
                platformos procesus bei mūsų santykius su Jumis, pavyzdžiui,
                susisiekti su Jumis telefonu elektroniniu paštu ar per
                socialinius kanalus ir pranešti, kada ir koks dalinimosi
                platformos funkcionalumas veikia ar pradės veikti netrukus,
                pakviesti Jus išbandyti atskirą platformos funkcionalumą,
                informuoti apie Jūsų norimo išsinuomoti ar išnuomoti automobilio
                išnuomojimą ir paruošimą perdavimui ar pristatymui į atitinkamą
                veiklos vykdymo vietą, priminti apie nuomos paslaugos pradžią ir
                (arba) pabaigą, susisiekti nuomoto automobilio autoįvykio ar
                kitokios žalos administravimo tikslais.
              </p>
              <p>
                Sutartys ir apskaitos dokumentai (fizine ir elektronine forma)
                yra saugomi 10 metų, skaičiuojant nuo pilno sutarties įvykdymo
                dienos.
              </p>
              <h3>Asmens duomenys, renkami užsakant tiesioginę rinkodarą</h3>
              <p>
                Jei sutikote gauti Mūsų tiesioginės rinkodaros pasiūlymus,
                naudosime Jūsų el. pašto adresą ir telefono numerį
                individualizuotai (automatizuotais sprendimais (profiliavimu))
                paremtai informacijai apie prekes, paslaugas, nuolaidas,
                pasiūlymus, konkursus, renginius, naujienas, apklausas bei
                kitoms naujienoms siųsti el. paštu, paštu, telefonu,
                trumposiomis žinutėmis ir šiais tikslais susisieksime su Jumis.
                Sukaupta informacija bus naudojama tik siunčiant
                naujienlaikraštį.
              </p>
              <p>
                Teikiant bendrus rinkodaros pasiūlymus, Jums bus siunčiama
                bendro pobūdžio informacija, kuria Duomenų valdytojai dalinsis
                su visais savo klientais.
              </p>
              <p>
                Teikiant individualizuotus rinkodaros pasiūlymus, automatizuotų
                sprendimų (profiliavimo) pagalba Jūs galite būti priskirtas
                atitinkamai Duomenų valdytojų klientų kategorijai pagal Jūsų
                domėjimosi (Duomenų valdytojų salonuose, el. paštu, telefonu,
                naršant Duomenų valdytojų tinklapiuose ar kitais būdais)
                konkrečiomis Duomenų valdytojų paslaugomis ir/ar prekėmis ir jų
                įsigijimo istorijos, dalyvavimo Duomenų valdytojų
                organizuojamose apklausose, konkursuose ir renginiuose duomenis
                bei kitus panašaus pobūdžio požymius. Šiais atvejais bendro
                turinio informacija bus siunčiama tik atitinkamai Duomenų
                valdytojų klientų kategorijai.
              </p>
              <p>
                Su Jumis Duomenų valdytojai gali susisiekti ir be aukščiau
                nurodyto sutikimo, jei siūlomos Duomenų valdytojų prekės ar
                paslaugos (ar panašios prekės/paslaugos) ar klausiama nuomonės
                dėl prekių/paslaugų. Pastaruoju atveju Duomenų valdytojai Jums
                sudaro lengvai įgyvendinamą galimybę nesutikti dėl atitinkamo
                pobūdžio pranešimų gavimo.
              </p>
              <p>
                Mūsų naujienlaikraštis bus siunčiamas nuo Duomenų valdytojo,
                tačiau Jūsų el. pašto adresą galime perduoti tretiesiems
                asmenims, teikiantiems specializuotas paslaugas, tik tam, kad
                išsiųsti Jums skirtą naujienlaikraštį. Duomenų (el. pašto adreso
                adresas ir telefono numeris) tvarkymo Jūsų sutikimu (Reglamento
                6 str. 1 d. a) p.) saugojimo terminas: 3 metai, bet ne ilgiau
                nei galioja Jūsų sutikimas. Tiesioginės rinkodaros pranešimų
                galite atsisakyti, apie atsisakymą pranešdami el. paštu{" "}
                <a href="mailto:info@trymycar.com?subject = Dėl mano duomenų tvarkymo&body = Noriu atsisakyti tiesioginių rinkodaros pranešimų">
                  {" "}
                  info@trymycar.com{" "}
                </a>{" "}
                arba paspaudę nuorodą, esančią naujienlaikraščio apačioje.
              </p>
              <h2>6. Asmens duomenų perdavimas</h2>
              <p>
                Jūsų asmens duomenys perduodami tam, kad būtų užtikrintas
                nepertraukiamas Mūsų veiklos tęstinumas ir tinkamas paslaugų
                teikimas bei prekių pristatymas, todėl mes galime atskleisti /
                perduoti informaciją apie Jus mūsų darbuotojams, vadybininkams,
                tarpininkams, tiekėjams, subrangovams, distributoriams, paslaugų
                teikėjams (IT paslaugas teikiančioms įmonėms, skolų išieškojimo,
                rinkodaros paslaugas teikiančioms įmonėms ir kt.) ar kitiems
                Mūsų partneriams, jei tik toks perdavimas reikalingas privatumo
                politikoje nurodytiems tikslams pasiekti.
              </p>
              <p>
                Tam tikromis aplinkybėmis galime būti įpareigoti perduoti asmens
                duomenis, kai:
              </p>
              <ul>
                <li>
                  informaciją turime atskleisti pagal įstatymus, įskaitant
                  atvejus, kai asmens duomenis turime atskleisti mokesčių
                  administratoriui ir teisėsaugos institucijoms nusikaltimų
                  prevencijos bei aptikimo tikslais;
                </li>
                <li>
                  asmens duomenis turime atskleisti dėl teisinių procedūrų arba
                  siekdami gauti teisinę konsultaciją, arba juos atskleisti yra
                  būtina siekiant nustatyti, įgyvendinti arba apginti mūsų
                  teises;
                </li>
                <li>
                  informaciją būtina atskleisti siekiant apsaugoti mūsų arba
                  trečiųjų asmenų interesus (pvz., užkirsti kelią sukčiavimui);
                </li>
                <li>
                  informaciją būtina atskleisti siekiant apsaugoti Jūsų
                  gyvybiškai svarbius interesus (pvz., jei pasijuntate blogai
                  mūsų patalpose ir mums tenka kreiptis medicininės pagalbos);
                </li>
                <li>
                  informacija turi būti atskleista trečiajai šaliai, kuri mūsų
                  vardu teikia duomenų tvarkymo paslaugas, t. y. duomenų
                  tvarkytojams. Susidarius tokioms aplinkybėms, įsipareigojame
                  imtis priemonių ir užtikrinti, kad duomenų tvarkytojai saugotų
                  asmens duomenis taip pat, kaip juos saugome mes, bei pranešti
                  Jums apie šio privatumo pranešimo pakeitimus;
                </li>
                <li>
                  informaciją būtina atskleisti potencialiam mūsų įmonės turto
                  ar organizacijos pirkėjui.
                </li>
              </ul>
              <h2>7. Asmens duomenų saugumo užtikrinimas</h2>
              <p>
                Suprantame, kad savo asmens duomenis mums pateikiate gera valia
                ir tikitės, kad jie bus apsaugoti. Dėl šios priežasties į Jūsų
                asmens duomenų saugumą žiūrime rimtai. Tai reiškia, kad siekdami
                tinkamai apsaugoti Jūsų asmens duomenis savo sistemose, imamės
                atitinkamų vidinių saugumo priemonių:
              </p>
              <ul>
                <li>
                  užtikriname griežtą prieigos kontrolę ir suteikiame prieigą
                  prie duomenų tik asmenims, kuriems juos yra būtina žinoti;
                </li>
                <li>
                  prieiga prie asmens duomenų yra apsaugota tinkamo lygio
                  slaptažodžiais;
                </li>
                <li>
                  sudarome konfidencialumo susitarimus su asmenimis, kurie turi
                  prieigą prie Jūsų duomenų;
                </li>
                <li>stebime prieigą prie asmens duomenų;</li>
                <li>
                  esame įdiegę kitas organizacines ir technines saugumo
                  priemones.
                </li>
              </ul>
              <h2>8. Jūsų teisės</h2>
              <p>
                Jūs, kaip duomenų subjektas, turite šias teises: (1) prašyti
                susipažinti su savo asmens duomenimis ir gauti jų kopiją; (2)
                prašyti, kad būtų ištaisyti ar apriboti netikslūs ar nepilni
                asmens duomenys; (3) prašyti, kad būtų ištrinti pertekliniai ar
                neteisėtai tvarkomi asmens duomenys; (4) prašyti perkelti savo
                asmens duomenis susistemintu, kompiuterio skaitomu formatu; (5)
                nesutikti, kad būtų tvarkomi jo asmens duomenys bei teisę
                atšaukti savo sutikimą, kai duomenų̨ tvarkymas grindžiamas
                duomenų subjekto sutikimu (pagal Reglamento 6 str. 1 d. a) p.);
                (6) pateikti skundą Valstybinei duomenų apsaugos inspekcijai
                (VDAI).
              </p>
              <h3>Teisė susipažinti su savo asmens duomenimis.</h3>
              <p>
                Mes siekiame, kad Jūs iki galo suprastumėte, kaip mes naudojame
                Jūsų asmens duomenis, ir dėl to nepatirtumėte jokių nepatogumų.
                Jūs galite sužinoti, ar mes tvarkome kokius nors Jūsų asmens
                duomenis. Jei Jūsų asmens duomenis tvarkome, Jūs turite teisę su
                jais susipažinti ir gauti jų kopiją.
              </p>
              <h3>
                Teisė ištaisyti savo asmens duomenis ir (ar) apriboti jų
                naudojimą.
              </h3>
              <p>
                Mes siekiame, kad visi tvarkomi asmens duomenys būtų pilni ir
                tikslūs, bei dėl jų netikslumo nepatirtumėte jokių nepatogumų.
                Todėl, pastebėję, jog naudojame nepilnus ir (ar) netikslius Jūsų
                asmens duomenis, Jūs galite pranešti, kad mes juos ištaisytume,
                tačiau tokiu atveju mes galime paprašyti Jūsų patvirtinti šią
                informaciją.
              </p>
              <p>
                Taip pat, galite prašyti, kad apribotume Jūsų asmens duomenų
                naudojimą, tam tikram laikotarpiui, kai: (1) reikia įsitikinti
                Jūsų asmens duomenų tikslumu (pateikus pretenzijas dėl duomenų
                tikslumo); (2) vykdomas Jūsų asmens duomenų tvarkymas (rinkimas,
                naudojimas) yra neteisėtas, tačiau nusprendžiate neprašyti
                ištrinti duomenų; (3) Jūsų asmens duomenys nebėra reikalingi
                konkretaus tikslo pasiekimui, tačiau jie gali būti reikalingi,
                kad galėtumėte nustatyti, įvykdyti arba apginti teisinį
                reikalavimą; (4) reikia nustatyti, ar mes turime svarbesnį
                teisinį pagrindą ir toliau tvarkyti Jūsų asmens duomenis (Jums
                pasinaudojus savo teise išreikšti prieštaravimą dėl asmens
                duomenų tvarkymo).
              </p>
              <p>
                Matydami, jog naudojame nepilnus ir (ar) akivaizdžiai
                neteisingus Jūsų asmens duomenis, Mes (savo iniciatyva) galime
                apriboti jų naudojimą ir (ar) kreiptis į Jus dėl minėtų duomenų
                ištaisymo.
              </p>
              <h3>Teisė ištrinti savo asmens duomenis.</h3>
              <p>
                Mes siekiame, kad Jūsų asmens duomenys būtų tvarkomi teisėtai,
                bei nerinkti ir (ar) nenaudoti perteklinių Jūsų asmens duomenų.
                Todėl, Jūs galite prašyti, kad mes ištrintume Jūsų asmens
                duomenis. Tačiau, tokia Jūsų teisė nėra absoliuti, tad Jūsų
                duomenis galėsime ištrinti tik jeigu: (1) asmens duomenys nebėra
                reikalingi, kad būtų pasiekti tikslai, kuriais jie buvo renkami
                arba kitaip tvarkomi; (2) Jūs atšaukėte savo duotą sutikimą dėl
                asmens duomenų tvarkymo ir Mes neturime jokio kito teisinio
                pagrindo šių asmens duomenų tvarkymui; (3) Jūs išreiškėte
                prieštaravimą (nesutikimą) dėl Jūsų asmens duomenų tvarkymo ir
                nėra viršesnių teisėtų priežasčių tvarkyti tokius Jūsų duomenis;
                (4) Jūsų asmens duomenys buvo tvarkomi neteisėtai; (5) tokie
                asmens duomenys turi būti ištrinti (t. y. negali būti renkami,
                naudojami ar saugomi) laikantis Mums taikomos, tesiės aktais
                nustatytos teisinės prievolės.
              </p>
              <h3>Teisė perkelti savo asmens duomenis.</h3>
              <p>
                Mes siekiame suteikti Jums, Jūsų asmens duomenų kontrolę bei
                užtikrinti laisvą asmens duomenų judėjimą. Todėl, Jūs galite
                prašyti, kad Jūsų pateikti asmens duomenys, kurie tvarkomi
                automatizuotomis priemonėmis būtų pateikiami Jums susistemintu,
                įprastai naudojamu ir kompiuterio skaitomu formatu ir (ar)
                persiųsti tuos duomenis kitam duomenų valdytojui (kai tai
                techniškai įmanoma). Ši teisė taip pat nėra absoliuti, todėl
                gali būti įgyvendinama tik, jeigu: (1) toks asmens duomenų
                tvarkymas grindžiamas sutikimu (pagal Reglamento 6 str. 1 d. a)
                p., 9 str., 2 d., a) p.) arba sutartimi (pagal Reglamento 6 str.
                1 d. b) p.); (2) kai šios teisės įgyvendinimas nedaro neigiamo
                poveikio kitų teisėms ir laisvėms.
              </p>
              <h3>
                Teisė nesutikti su asmens duomenų tvarkymu ir (ar) atšaukti savo
                duotą sutikimą.
              </h3>
              <p>
                Mes siekiame suteikti Jums galimybę kontroliuoti savo asmens
                duomenis. Todėl, Jūs galite bet kuriuo metu, išreikšti savo
                prieštaravimą (nesutikimą) dėl konkrečių Jūsų asmens duomenų
                tvarkymo, kai toks duomenų tvarkymas vykdomas vadovaujantis Mūsų
                teisėtu interesu (pagal Reglamento 6 str. 1 d. f p.), įskaitant
                profiliavimą remiantis tomis nuostatomis. Nepaisant to, Mes
                galime ir toliau tvarkyti šiuos Jūsų asmens duomenis, jeigu
                galime įrodyti, kad šie duomenys tvarkomi dėl įtikinamų teisėtų
                priežasčių, kurios yra viršesnės už Jūsų (duomenų subjekto)
                interesus, teises ir laisves, arba siekiant pareikšti, vykdyti
                ar apginti teisinius reikalavimus.
              </p>
              <p>
                Kai Jūsų asmens duomenys tvarkomi tiesioginės rinkodaros
                tikslais, Jūs turi teisę bet kuriuo metu nesutikti, kad su Jumis
                susiję asmens duomenys būtų tvarkomi tokios rinkodaros tikslais,
                įskaitant profiliavimą, kiek jis susijęs su tokia tiesiogine
                rinkodara. Tokiu atveju, Mes nebetvarkysime Jūsų asmens duomenų
                tiesioginės rinkodaros tikslais.
              </p>
              <p>
                Taip pat, kai Jūsų asmens duomenys yra tvarkomi Jūsų sutikimo
                pagrindu (pagal Reglamento 6 str. 1 d. a) p., arba Reglamento 9
                str. 2 d., a) p.), Jūs galite bet kuriuo metu, atšaukti savo
                duotą sutikimą dėl tokios asmens duomenų tvarkymo.
              </p>
              <h3>Teisė pateikti skundą priežiūros institucijai (VDAI).</h3>
              <p>
                Mes visuomet siekiame atsakyti į Jums kylančius klausimus ir
                (ar) išspręsti problemas, kylančias dėl asmens duomenų tvarkymo,
                bei rasti abiem pusėms tinkamiausią sprendimą, todėl turint
                klausimų ir (ar) nusiskundimų Mūsų asmens duomenų apsauga,
                raginame kreiptis tiesiogiai į Mus, el. paštu:{" "}
                <a href="mailto:info@trymycar.com">info@trymycar.com</a>, arba
                telefonu: <strong>+370 625 13762</strong>&gt;. Jeigu nesutinkate
                su Mūsų pateiktais atsakymais ir (ar) pasiūlytais sprendimais
                bei ir toliau manote kad su jumis susijusių asmens duomenų
                tvarkymas pažeidžia galiojančius teisės aktus, Jūs turite teisę
                pateikti skundą Valstybinei duomenų apsaugos inspekcijai (el.
                paštu: <a href="maialto:ada@ada.lt">ada@ada.lt</a>).
              </p>
              <h2>9. Jūsų teisių įgyvendinimas.</h2>
              <p>
                Aukščiau nurodytas savo teises, Jūs galite įgyvendinti šiais
                būdais: (1) teikiant Mums rašytinį prašymą asmeniškai (UAB
                Nuomos Sistema), paštu ir (ar) per atstovą ar adresu:
                Santariškių g. 75-34, LT-08457 Vilnius; (2) teikiant Mums
                prašymą elektroninių ryšių priemonėmis, t. y. el. paštu:{" "}
                <a href="mailto:info@trymycar.com">info@trymycar.com</a>.
              </p>
              <p>
                Tam, kad galėtume priimti ir įgyvendinti Jūsų prašomas duomenų
                subjekto teises, pateikdamas prašymą, Jūs privalote patvirtinti
                savo tapatybę vienu iš šių būdų:
              </p>
              <ul>
                <li>
                  pateikdamas prašymą Nuomos sistema darbuotojui – kartu
                  pateikiant galiojantį asmens tapatybę patvirtinantį dokumentą;
                </li>
                <li>
                  pateikdamas prašymą paštu ar per pasiuntinį – kartu pridėdamas
                  galiojančio asmens tapatybę patvirtinančio dokumento kopiją,
                  patvirtintą teisės aktų nustatyta tvarka;
                </li>
                <li>
                  pateikdamas prašymą elektroniniu būdu – jį patvirtinant
                  elektroninių ryšių priemonėmis, kurios leidžia tinkamai
                  identifikuoti asmenį (pvz., mobiliuoju parašu, kvalifikuotu
                  elektroniniu parašu ar pan.).
                </li>
              </ul>
              <p>
                Gavę Jūsų prašymą dėl duomenų subjektų teisių įgyvendinimo
                nedelsdami, bet ne vėliau kaip per 1 mėnesį nuo kreipimosi
                dienos, pateiksime Jums atsakymą. Šis laikotarpis prireikus gali
                būti pratęstas dar 1 mėnesiui, atsižvelgiant į prašymų
                sudėtingumą ir skaičių. Apie tokį pratesimą būsite papildomai
                informuojami dar pirmąjį mėnesį. Jūsų prašoma informacija bus
                teikiama nemokamai. Tačiau, matydami, kad Jūsų prašymai yra
                akivaizdžiai nepagrįsti arba neproporcingi, visų pirma dėl jų
                pasikartojančio turinio, Mes turime teisę imti už tai pagrįstą
                mokestį (t. y. prašyti atlyginti administracines išlaidas) arba
                atsisakyti imtis veiksmų pagal tokį Jūsų prašymą.
              </p>
              <p>
                Atsakymas bus pateikiamas Jūsų prašyme pasirinktu būdu. Jeigu
                prašyme nenurodote būdo, kuriuo norite gauti atsakymą, atsakymas
                Jums bus siunčiamas tokiu pat būdu, kokiu buvo pateikiamas
                prašymas.
              </p>
              <h2>10. Baigiamosios nuostatos.</h2>
              <p>
                Tikimės, kad Jūs suprasite, jog aptarti visus įmanomus asmens
                duomenų rinkimo ir naudojimo būdus šiame trumpame pranešime yra
                labai sudėtinga. Nepaisant to, Mes stengiamės pateikti kuo
                aiškesnę ir išsamesnę informaciją bei įsipareigojame atnaujinti
                šį privatumo pranešimą, pasikeitus asmens duomenų tvarkymo
                procesams.
              </p>
              <p>
                Jei turite kokių nors klausimų apie Jūsų asmens duomenų
                naudojimą, džiaugsimės galėdami į juos atsakyti arba suteiksime
                visą papildomą informaciją, kurią galime atskleisti. Visuomet
                galite kreiptis į Mus el. paštu{" "}
                <a href="mailto:info@trymycar.com">info@trymycar.com</a> arba
                paskambinę telefonu: <strong>+370 625 13762</strong>.
              </p>
              <p>
                Mes turime teisę iš dalies arba visiškai pakeisti šią Privatumo
                politiką. Apie Privatumo politikos pakeitimus papildomai
                informuojami nebūsite, t. y. atnaujinta Privatumo politikos
                redakcija bus paskelbiama Svetainėje. Todėl, rekomenduojame ir
                raginame Jus periodiškai apsilankyti mūsų Svetainėje ir
                susipažinti su naujausia Privatumo politikos versija.
              </p>
              <p>Paskutinis atnaujinimas: 2020-12-16.</p>

        </div>
        </Container>
    </Section>
  );
}

export default PrivacyPolicy;
